/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     PortalRedirect
//   Details:    PortalRedirect compoment
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 106380 30/04/20 JC       New
// 103839 13/05/20 JC  M01  Added TeamPortal redirect
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { portalRedirectActions } from '../store/PortalRedirect';
import { systemControlActions } from '../store/SystemControl';
import Header from '../components/Header';
import Loading from '../components/Loading';
import AlertPanel from '../components/AlertPanel';
import { portalRedirectTypes } from '../constants/PortalRedirectTypes';

class PortalRedirect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            portalredirecttype: -1
        };
    }

    // This method runs when the component is first added to the page
    componentDidMount() {
		
        //pulls compnents off the route path paramers...
        const { portalredirecttype } = this.props.match.params;

        const { systemControl } = this.props;

        //set in page state
        this.setState({
            portalredirecttype: portalredirecttype
        });

        //get the LoginURL 
        let portalLoginURL = ""; //M01
        //M01 based on portal redirect type
        if (systemControl) {
            if (portalredirecttype == portalRedirectTypes.managerPortal && systemControl.configuration && systemControl.configuration.mpLoginURL) {
                portalLoginURL = systemControl.configuration.mpLoginURL;
            } else if (portalredirecttype == portalRedirectTypes.teamPortal && systemControl.configuration && systemControl.configuration.tpLoginURL) {
                portalLoginURL = systemControl.configuration.tpLoginURL;
            }
        }

        //and passes into the props toPortal
        this.props.toPortal(portalredirecttype, portalLoginURL);  //M01

        //force the focus away from the link item
        document.activeElement.blur();
    }

    // This method runs when the component is unmounting to clear up the portal redirect
    componentWillUnmount() {

        //clean up the store
        this.props.cleanUp();       
    }
    
	render() {
        let { isLoading, error, portalRedirectType, portalRedirect } = this.props;

        //get the title
        let title = "";
        switch (portalRedirectType) {
            case portalRedirectTypes.managerPortal:
                title="Manager Portal"
                break;
            case portalRedirectTypes.teamPortal: //M01
                title = "Team Portal"
                break;
            default:
                break;
        }

        //no error, but an error on portalRedirect?
        if (!error && portalRedirect && portalRedirect.error) {
            error = portalRedirect.error;
        }
        
		return (
			<div>
                <Header title={title} />

				<div>
					{error ? <AlertPanel type="danger" message={error} /> : []}

					{isLoading ? <Loading /> : []}
				</div>
			</div>
		);
	}
}

PortalRedirect.propTypes = {
    ssoAuthenticationTicket: PropTypes.string,
	error: PropTypes.string,
	isLoading: PropTypes.bool
};

export default connect(
    state => ({ portalRedirect: state.portalRedirect, systemControl: state.systemControl }),
    dispatch => bindActionCreators({ ...portalRedirectActions, ...systemControlActions }, dispatch)
)(PortalRedirect);
